import { z } from "zod";
import { formatCnpj } from "@/lib/format";

// `uf` é só filtro da lista de municípios (não vai pro backend). Os demais campos
// são o registro inteiro de cnpj_localizacao que o PUT sobrescreve — o diálogo
// sempre manda todos (D14), partindo do que já existe quando é correção.
export const localizacaoSchema = z.object({
  uf: z.string().min(1, "Selecione a UF."),
  codigoIbge: z.string().regex(/^\d{7}$/, "Selecione o município."),
  razaoSocial: z.string().max(255).optional(),
  situacaoAnvisa: z.string().optional(),
  observacao: z.string().max(500, "Máximo de 500 caracteres.").optional(),
});

export type LocalizacaoFormValues = z.infer<typeof localizacaoSchema>;

export const SITUACOES_ANVISA = [
  { value: "ATIVA", label: "Autorização ativa" },
  { value: "NAO_ENCONTRADA", label: "Não encontrada" },
  { value: "CANCELADA", label: "Cancelada / suspensa" },
  { value: "NAO_CONSULTADA", label: "Não consultada" },
];

// Consulta pública de funcionamento de empresas da Anvisa, já no resultado do CNPJ
// (rota conferida em 2026-10-07). A Anvisa tem hCaptcha nessa consulta e pode mudar a
// rota sem aviso; por isso ConsultaAnvisa também oferece "copiar CNPJ".
export function linkConsultaAnvisa(cnpj: string): string {
  return `https://consultas.anvisa.gov.br/#/empresas/empresas/q/?cnpj=${cnpj.replace(/\D/g, "")}`;
}

// Consulta pública do CNES (DATASUS). Não aceita o código na URL: abre a busca e o
// CNES é colado à mão (ConsultaCnes oferece "copiar CNES").
export const LINK_CONSULTA_CNES = "https://cnes.datasus.gov.br/pages/estabelecimentos/consulta.jsp";

/** "CNPJ 00.000.000/0000-00" ou, sem CNPJ (estabelecimento público), "CNES 0000000". */
export function rotuloEstabelecimento({ cnpj, cnes }: { cnpj?: string; cnes?: string }): string {
  return cnpj ? `CNPJ ${formatCnpj(cnpj)}` : `CNES ${cnes ?? "—"}`;
}
